import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, MessageCircleIcon, ShareIcon, BookmarkIcon, PlusIcon } from 'lucide-react';
import { Avatar } from '../ui/Avatar';
interface ActionRailProps {
  user: any;
  likes: string;
  comments: string;
  shares: string;
  isLikedInitial?: boolean;
  onOpenComments: () => void;
  onOpenShare: () => void;
}
export function ActionRail({
  user,
  likes,
  comments,
  shares,
  isLikedInitial = false,
  onOpenComments,
  onOpenShare
}: ActionRailProps) {
  const [isLiked, setIsLiked] = useState(isLikedInitial);
  const [isSaved, setIsSaved] = useState(false);
  const [isFollowing, setIsFollowing] = useState(false);
  return <div className="absolute right-4 bottom-24 flex flex-col items-center gap-6 z-20" data-id="element-63">
      {/* Profile */}
      <div className="relative mb-2" data-id="element-64">
        <Avatar src={user.avatar} alt={user.username} size="lg" className="border-2 border-white" data-id="element-65" />
        {!isFollowing && <motion.button whileTap={{
        scale: 0.8
      }} onClick={() => setIsFollowing(true)} className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-6 h-6 bg-primary rounded-full flex items-center justify-center border-2 border-black" data-id="element-66">
            <PlusIcon size={14} className="text-[#121212]" strokeWidth={3} data-id="element-67" />
          </motion.button>}
      </div>

      {/* Like */}
      <div className="flex flex-col items-center gap-1" data-id="element-68">
        <motion.button whileTap={{
        scale: 0.8
      }} onClick={() => setIsLiked(!isLiked)} className="w-12 h-12 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-full" data-id="element-69">
          <HeartIcon size={28} className={isLiked ? 'text-neonOrange fill-neonOrange' : 'text-white'} strokeWidth={isLiked ? 0 : 2} data-id="element-70" />
        </motion.button>
        <span className="text-white text-xs font-medium drop-shadow-md" data-id="element-71">
          {likes}
        </span>
      </div>

      {/* Comment */}
      <div className="flex flex-col items-center gap-1" data-id="element-72">
        <motion.button whileTap={{
        scale: 0.8
      }} onClick={onOpenComments} className="w-12 h-12 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-full" data-id="element-73">
          <MessageCircleIcon size={28} className="text-white fill-white/20" strokeWidth={2} data-id="element-74" />
        </motion.button>
        <span className="text-white text-xs font-medium drop-shadow-md" data-id="element-75">
          {comments}
        </span>
      </div>

      {/* Save */}
      <div className="flex flex-col items-center gap-1" data-id="element-76">
        <motion.button whileTap={{
        scale: 0.8
      }} onClick={() => setIsSaved(!isSaved)} className="w-12 h-12 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-full" data-id="element-77">
          <BookmarkIcon size={28} className={isSaved ? 'text-primary fill-primary' : 'text-white'} strokeWidth={isSaved ? 0 : 2} data-id="element-78" />
        </motion.button>
        <span className="text-white text-xs font-medium drop-shadow-md" data-id="element-79">
          Save
        </span>
      </div>

      {/* Share */}
      <div className="flex flex-col items-center gap-1" data-id="element-80">
        <motion.button whileTap={{
        scale: 0.8
      }} onClick={onOpenShare} className="w-12 h-12 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-full" data-id="element-81">
          <ShareIcon size={28} className="text-white fill-white/20" strokeWidth={2} data-id="element-82" />
        </motion.button>
        <span className="text-white text-xs font-medium drop-shadow-md" data-id="element-83">
          {shares}
        </span>
      </div>

      {/* Music Disc */}
      <motion.div animate={{
      rotate: 360
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'linear'
    }} className="w-12 h-12 rounded-full bg-surface2 border-[10px] border-black flex items-center justify-center mt-2 shadow-lg" data-id="element-84">
        <div className="w-3 h-3 bg-primary rounded-full" data-id="element-85" />
      </motion.div>
    </div>;
}